import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Select from "react-select";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import CustomerCreate from "./CustomerCreate";
import CustomerEdit from "./CustomerEdit";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import { getCustomers } from "../../../helpers/urlConfig/apiFunctions";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { documentTitle } from "../../../helpers/documentTitle";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const CustomerList = () => {
  const [customer_modal_list, set_customer_modal_list] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [editCustomerData, setEditCustomerData] = useState(null);
  const [deleteId, setDeleteProductId] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customerNameOptions, setCustomerNameOptions] = useState([]);
  const [placeOptions, setPlaceOptions] = useState([]);
  const [mobileNumberOptions, setMobileNumberOptions] = useState([]);

  const [selectedCustomerName, setSelectedCustomerName] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [selectedMobileNumber, setSelectedMobileNumber] = useState(null);

  const customer_tog_list = () => set_customer_modal_list(!customer_modal_list);
  const edit_tog_list = () => set_edit_modal_list(!edit_modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);

  documentTitle("Customers");

  const fetchData = async () => {
    try {
      const response = await getCustomers();

      if (response.statusCode === 200) {
        setCustomers(response.data);
        setFilteredCustomers(response.data);

        // Populate the dropdown options
        setCustomerNameOptions(
          response.data.map((customer) => ({
            value: customer.customer_name,
            label: customer.customer_name,
          }))
        );

        setPlaceOptions(
          response.data
            .map((customer) => ({
              value: customer.place,
              label: customer.place,
            }))
            .filter((place, index, self) => {
              // Remove duplicates
              return index === self.findIndex((p) => p.value === place.value);
            })
        );

        setMobileNumberOptions(
          response.data
            .map((customer) => ({
              value: customer.phone_number,
              label: customer.phone_number,
            }))
            .filter(
              (phone, index, self) =>
                index === self.findIndex((p) => p.value === phone.value)
            )
        );
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEditChanges = (data) => {
    setEditCustomerData(data);
    edit_tog_list();
  };

  const onClickRemoveBtn = (id) => {
    setDeleteProductId(id);
    tog_delete();
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredCustomers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");
    XLSX.writeFile(workbook, "Customers.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Customer List", 14, 10);
    doc.autoTable({
      head: [["SL.No", "Customer", "Phone", "Place", "Address", "GST Details"]],
      body: filteredCustomers.map((customer, index) => [
        index + 1,
        customer.customer_name,
        customer.phone_number,
        customer.place,
        customer.address,
        customer.gst_details,
      ]),
    });
    doc.save("Customers.pdf");
  };

  const handleFilter = () => {
    let filtered = customers;

    if (selectedCustomerName) {
      filtered = filtered.filter(
        (customer) => customer.customer_name === selectedCustomerName.value
      );
    }

    if (selectedPlace) {
      filtered = filtered.filter(
        (customer) => customer.place === selectedPlace.value
      );
    }

    if (selectedMobileNumber) {
      filtered = filtered.filter(
        (customer) => customer.phone_number === selectedMobileNumber.value
      );
    }

    setFilteredCustomers(filtered);
  };

  useEffect(() => {
    handleFilter();
  }, [selectedCustomerName, selectedPlace, selectedMobileNumber]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Customer List"
            pageTitle="Customer"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1"
                            onClick={customer_tog_list}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            Add
                          </Button>
                          {/* <Button
                            color="primary"
                            onClick={exportToExcel}
                            className="me-1"
                          >
                            Excel
                          </Button>
                          <Button color="secondary" onClick={exportToPDF}>
                            PDF
                          </Button> */}
                        </div>
                      </Col>
                      <Col className="col-sm">
                        <Row>
                          <Col md={4}>
                            <Select
                              options={customerNameOptions}
                              placeholder="Filter by Customer Name"
                              isClearable
                              value={selectedCustomerName}
                              onChange={(option) =>
                                setSelectedCustomerName(option)
                              }
                            />
                          </Col>
                          <Col md={4}>
                            <Select
                              options={mobileNumberOptions}
                              placeholder="Filter by Mobile No"
                              isClearable
                              value={selectedMobileNumber}
                              onChange={(option) =>
                                setSelectedMobileNumber(option)
                              }
                            />
                          </Col>
                          <Col md={4}>
                            <Select
                              options={placeOptions}
                              placeholder="Filter by Place"
                              isClearable
                              value={selectedPlace}
                              onChange={(option) => setSelectedPlace(option)}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table className="table align-middle table-nowrap">
                        <thead className="table-light">
                          <tr>
                            <th>SL.No</th>
                            <th>Customer</th>
                            <th>Phone</th>
                            <th>Place</th>
                            <th>Address</th>
                            <th>GST Details</th>
                            <th>Pan Details</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredCustomers.map((customer, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{customer.customer_name || "-"}</td>
                              <td>{customer.phone_number || "-"}</td>
                              <td>{customer.place || "-"}</td>
                              <td>{customer.address || "-"}</td>
                              <td>{customer.gst_details || "-"}</td>
                              <td>{customer.pan_details || "-"}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <div className="edit">
                                    <button
                                      className="btn btn-sm btn-success"
                                      onClick={() =>
                                        handleEditChanges(customer)
                                      }
                                    >
                                      Edit
                                    </button>
                                  </div>
                                  <div className="remove">
                                    <button
                                      className="btn btn-sm btn-danger"
                                      onClick={() =>
                                        onClickRemoveBtn(customer.customer_id)
                                      }
                                    >
                                      Remove
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {filteredCustomers.length === 0 && (
                        <div className="text-center mt-4">
                          <p>No customers found.</p>
                        </div>
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <CustomerCreate
        customer_modal_list={customer_modal_list}
        set_customer_modal_list={set_customer_modal_list}
        customer_tog_list={customer_tog_list}
        fetchData={fetchData}
      />

      {edit_modal_list && (
        <CustomerEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={edit_tog_list}
          editCustomerData={editCustomerData}
          fetchData={fetchData}
        />
      )}

      {/* Delete Confirmation Modal */}
      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="Customer"
      />
    </React.Fragment>
  );
};

export default CustomerList;
